<template>
  <q-table
    v-if="selectedInventoryRecipeId && inventoryRecipeOptions.length"
    :rows="availabilitiesAndConstraints"
    :columns="availabilitiesAndConstraintsColumns"
    row-key="location"
    :hide-bottom="true"
  >
    <template #top>
      <q-select
        v-model="selectedInventoryRecipeId"
        class="full-width"
        label="Inventory Recipe"
        :options="inventoryRecipeOptions"
        map-options
        emit-value
      />
    </template>
    <template #body="props">
      <q-tr :props="props">
        <q-td
          key="location"
          :props="props"
        >
          {{ props.row.location }}
        </q-td>
        <q-td
          key="available"
          :props="props"
        >
          <q-chip :label="props.row.available">
            <q-tooltip>
              <div
                v-for="(constraint, index) in props.row.constraints"
                :key="constraint + ':' + index"
                class="col-auto"
              >
                {{ constraint }}
              </div>
            </q-tooltip>
          </q-chip>
        </q-td>
      </q-tr>
    </template>
  </q-table>
</template>

<script>
export default {
  name: 'AvailabilitiesAndConstraints',
  configuration: ['currentSite', 'inventoryItems'],
  props: {
    itemVariationOrModifier: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      selectedInventoryRecipeId: null
    }
  },
  computed: {
    inventoryRecipeOptions () {
      return _.map(this.itemVariationOrModifier.inventoryRecipes.data, inventoryRecipe => ({
        value: inventoryRecipe.id,
        label: inventoryRecipe.name
      }))
    },
    availabilitiesAndConstraintsColumns () {
      const columns = [
        { name: 'location', label: 'Location', field: 'location', align: 'left' },
        { name: 'available', label: 'Available', field: 'available' }
      ]

      return columns
    },
    availabilitiesAndConstraints () {
      if (!this.selectedInventoryRecipeId || !this.currentSite.activeInventoryStrategy) return []

      const { locations, registerStations } = this.currentSite.activeInventoryStrategy

      return _(locations.data).concat(registerStations.data).map(locationOrRegisterStation => {
        const inventoryStrategyEntityKey = locationOrRegisterStation.typeName === 'RegisterStation' ? 'register_stations' : 'locations'
        const availabilitiesAndConstraintsObjectForItemVariationOrModifier = _.get(
          this.itemVariationOrModifier.inventoryAvailabilitiesAndConstraintsByLocationAndRegisterStation,
          [inventoryStrategyEntityKey, locationOrRegisterStation.id, this.selectedInventoryRecipeId],
          { available: 0, constraints: [] }
        )
        return {
          location: locationOrRegisterStation.inventoryStrategyEntityDisplayName,
          available: availabilitiesAndConstraintsObjectForItemVariationOrModifier.available || 0,
          constraints: availabilitiesAndConstraintsObjectForItemVariationOrModifier.constraints.map(([inventoryItemId, available]) => {
            const inventoryItem = _.find(this.inventoryItems.data, inventoryItem => inventoryItem.id === Number(inventoryItemId))
            return inventoryItem?.name + ': ' + available
          })
        }
      }).value()
    }
  },
  watch: {
    'itemVariationOrModifier.id': {
      handler: function () {
        this.selectedInventoryRecipeId = _.first(this.inventoryRecipeOptions)?.value || null
      },
      immediate: true
    }
  }
}
</script>
